var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { UPLOAD_FILE_REQUEST, uploadFileSuccess, uploadFileFailure } from '../../actions';
import APIIN from '../../../utils/APIIN';
const uploadFile = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append('file', action.payload);
        try {
            APIIN.formUpload('/order/add/batch', { file: action.payload })
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            reject(error);
        }
    }));
});
function* uploadFileWorker(action) {
    try {
        const response = yield call(uploadFile, action);
        yield put(uploadFileSuccess(response));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            yield put(uploadFileFailure(error.response.data.message));
        }
        else {
            yield put(uploadFileFailure('An error occurred while uploading the file'));
        }
    }
}
export function* watchUploadFile() {
    yield takeLatest(UPLOAD_FILE_REQUEST, uploadFileWorker);
}
